import * as Sentry from '@sentry/react';
import axios from 'axios';
import { SENTRY_ENVIRONMENT, USER } from '../../constants';
import * as ActionTypes from '../action-types';

export function authCheck() {
  return {
    type: ActionTypes.AUTH_CHECK
  };
}

export const authCheckAsync = () => async dispatch => {
  const localUser = JSON.parse(localStorage.getItem(USER));
  //isUserLoggedIn comes from the window object.
  if (!localUser && isUserLoggedIn) {
    try {
      await axios.post('/logout');
      localStorage.removeItem(USER);
      window.isUserLoggedIn = false;
      window.variantForFreeShippingExperiment = 0;

      dispatch(authCheck());
    } catch (err) {
      localStorage.removeItem(USER);
      window.isUserLoggedIn = false;
      window.variantForFreeShippingExperiment = 0;
      console.log('ERROR LOGGING OUT', err);
    }
  } else {
    if (window.environment === SENTRY_ENVIRONMENT && localUser) {
      Sentry.setUser({ email: localUser?.email });
    }
    dispatch(authCheck());
  }
};

export const showLoader = () => ({
  type: ActionTypes.SHOW_LOADER
});

export const hideLoader = () => ({
  type: ActionTypes.HIDE_LOADER
});

export const updateUserLocalStorage = payload => ({
  type: ActionTypes.UPDATE_USER_LOCAL_STORAGE,
  payload
});

export const updateUserNameLocalStorage = payload => ({
  type: ActionTypes.UPDATE_USER_NAME_LOCAL_STORAGE,
  payload
});

export const notification = payload => ({
  type: ActionTypes.SHOW_NOTIFICATION,
  payload
});

export const deleteLocalCartItem = productId => {
  return { type: ActionTypes.DELETE_LOCAL_CART_ITEM, productId };
};

export const addLocalCartItem = swatch => {
  return { type: ActionTypes.ADD_SWATCH_LOCAL_CART_ITEM, swatch };
};

export const addGiftCardLocalCartItem = giftCard => {
  return { type: ActionTypes.ADD_GIFT_CARD_LOCAL_CART_ITEM, giftCard };
};

export const updateGiftCardLocalCartItem = cartProduct => {
  return { type: ActionTypes.UPDATE_GIFT_CARD_LOCAL_CART_ITEM, cartProduct };
};

export const addProductLocalCart = (
  product,
  quantity,
  source = '',
  extendPlan = null
) => {
  return {
    type: ActionTypes.ADD_PRODUCT_LOCAL_CART_ITEM,
    product,
    quantity,
    source,
    extendPlan
  };
};

export const addExtendToProduct = (product, extendPlan) => {
  return {
    type: ActionTypes.ADD_EXTEND_TO_PRODUCT,
    product,
    extendPlan
  };
};

export const removeExtendFromProduct = product => {
  return {
    type: ActionTypes.REMOVE_EXTEND_FROM_PRODUCT,
    product
  };
};

export const resetLocalCartItem = () => {
  return { type: ActionTypes.RESET_LOCAL_CART_ITEM };
};

export const increaseProductLocalCartItem = productId => {
  return {
    type: ActionTypes.INCREASE_PRODUCT_LOCAL_CART_ITEM,
    productId
  };
};

export const updateProductQuantity = ({ productId, quantity }) => {
  return {
    type: ActionTypes.UPDATE_PRODUCT_QUANTITY,
    productId,
    quantity
  };
};

export const decreaseProductLocalCartItem = productId => {
  return {
    type: ActionTypes.DECREASE_PRODUCT_LOCAL_CART_ITEM,
    productId
  };
};

export const addProductIdToWaitlist = productId => {
  return {
    type: ActionTypes.ADD_PRODUCT_TO_WAITLIST,
    productId
  };
};

export const addShippingServiceId = (
  productId,
  shippingServiceId,
  shippingServicePrice
) => {
  return {
    type: ActionTypes.ADD_SHIPPING_SERVICE_ID,
    productId,
    shippingServiceId,
    shippingServicePrice
  };
};
export const removeShippingServiceId = productId => {
  return {
    type: ActionTypes.REMOVE_SHIPPING_SERVICE_ID,
    productId
  };
};

// Authentication logic

export const loginSuccess = payload => ({
  type: ActionTypes.LOGIN_SUCCESS,
  payload
});

export const loginError = payload => ({
  type: ActionTypes.LOGIN_ERROR,
  payload
});

export const logout = payload => ({
  type: ActionTypes.LOGOUT,
  payload
});

export const loginLoading = payload => ({
  type: ActionTypes.LOGIN_LOADING,
  payload
});

//GLOBAL STARTS

export const setOpenLoginModal = payload => ({
  type: ActionTypes.SET_OPEN_LOGIN_MODAL,
  payload
});

export const setCustomerOverlayNav = payload => ({
  type: ActionTypes.SET_CUSTOMER_OVERLAY_NAV,
  payload
});

export const setOpenFabricModal = payload => ({
  type: ActionTypes.SET_OPEN_FABRIC_MODAL,
  payload
});

export const setFabricModalData = payload => ({
  type: ActionTypes.SET_FABRIC_MODAL_DATA,
  payload
});

export const toggleGlobalCart = payload => ({
  type: ActionTypes.TOGGLE_GLOBAL_CART,
  payload
});

export const handleGlobalCart = payload => ({
  type: ActionTypes.HANDLE_GLOBAL_CART,
  payload
});

export const handlePhotoSidebar = payload => {
  return {
    type: ActionTypes.HANDLE_PHOTO_SIDEBAR,
    payload
  };
};

//ENDS GLOBAL

export const loginAsync = (email, password) => async dispatch => {
  dispatch(loginLoading(true));

  try {
    await axios.get('/sanctum/csrf-cookie');
    await axios.post('/login', {
      email,
      password,
      remember: true
    });
    //isUserLoggedIn comes from the window object.
    window.isUserLoggedIn = true;
  } catch (err) {
    localStorage.removeItem(USER);
    dispatch(hideLoader());
    dispatch(loginError('Please check your email or password'));
  }
};

export const logoutAsync = () => async dispatch => {
  try {
    await axios.post('/logout');
    localStorage.removeItem(USER);
    //isUserLoggedIn comes from the window object.
    window.isUserLoggedIn = false;
    window.variantForFreeShippingExperiment = 1;
    dispatch(logout());
  } catch (err) {
    window.isUserLoggedIn = false;
    window.variantForFreeShippingExperiment = 1;
    console.log('ERROR LOGGING OUT');
  }
};

export const saveUser = payload => ({
  type: ActionTypes.SAVE_USER,
  payload
});

export const saveUserAsync = user => dispatch => {
  localStorage.setItem(USER, JSON.stringify(user));
  dispatch(saveUser(user));
  if (window.environment === SENTRY_ENVIRONMENT) {
    Sentry.setUser({ email: user?.email });
  }
};
